export const blockIconsCommunicationOutgoingMailNew = (
	<span className='material-symbols-outlined'>outgoing_mail</span>
);
